import type { TFunction } from "i18next";
import FeedbackRequestDto from "../../../../types/feedback/FeedbackRequestDto";

/** Single-line dashboard copy: self-request vs manager/other requesting for someone else. */
export function formatPendingRequestSummary(
  request: FeedbackRequestDto,
  t: TFunction
): string {
  const requesterName =
    request.requesterName ??
    t("Common.Someone", { defaultValue: "Someone" });
  const journeyTitle =
    request.journeyTitle?.trim() ||
    t("Feedback.Dashboard.ReviewFallback", { defaultValue: "review" });

  if (request.requesterIsSubject) {
    return t("Feedback.Dashboard.RequestSummarySelf", {
      requesterName,
      journeyTitle,
      defaultValue:
        "{{requesterName}} has requested your feedback on their {{journeyTitle}}",
    });
  }

  const subjectName = request.subjectEmployeeName?.trim();
  if (subjectName) {
    return t("Feedback.Dashboard.RequestSummaryOther", {
      requesterName,
      subjectName,
      journeyTitle,
      defaultValue:
        "{{requesterName}} has requested your feedback on {{subjectName}}'s {{journeyTitle}}",
    });
  }

  return t("Feedback.Dashboard.RequestSummaryNoSubject", {
    requesterName,
    journeyTitle,
    defaultValue:
      "{{requesterName}} has requested your feedback on {{journeyTitle}}",
  });
}
